<template>
	<transition name="fade">
		<div v-if="show">
			<div :style="cssProps" class="alert">
				<span class="closebtn" @click="$emit('show', !show)"
					>&times;</span
				>
				<b>{{ title }}</b>
				<span> {{ message }}</span>
			</div>
		</div>
	</transition>
</template>
<script>
export default {
    name: 'Alert',
    props: {
        title: {
            type: String,
            default: 'Atenção!',
        },
        message: {
            type: String,
            default: 'Um Erro Inesperado Aconteceu',
        },
        color: {
            type: String,
            default: 'red',
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        cssProps() {
            return {
                '--color': this.color,
            };
        },
    },
};
</script>

<style>
.alert {
	padding: 20px;
	background-color: var(--color);
	color: white;
}

.closebtn {
	margin-left: 15px;
	color: white;
	font-weight: bold;
	float: right;
	font-size: 22px;
	line-height: 20px;
	cursor: pointer;
	transition: 0.3s;
}

.closebtn:hover {
	color: #d0d0d0;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
